<span class="form-input-password">
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+field) | translate" class="input-label"></label>
  <p-password [id]="id" (input)="onInput($event)" [feedback]="feedback" [toggleMask]="true"
    [disabled]="formControl['disabled']"></p-password>
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"
    [passwordRepeat]="formControl.errors?.['passwordRepeat']"></app-form-input-error>
</span>
